import useStoreSelector from 'store/useStoreSelector';

function useTokenHasExpired() {
	const { expired } = useStoreSelector(({ session }) => session);

	return expired;
}

export default useTokenHasExpired;
